/**
 * @desc 暂存区列表导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stagingAreaMaster.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/stagingAreaMaster/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
